import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Typography } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { post } from '../../utils/http';

const { Title } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const res = await post('/api/manage/login', { password: values.password });
      if (res.data && res.data.code === 0) {
        message.success('登录成功');
        localStorage.setItem('admin_token', res.data.data.token);
        
        // 尝试返回登录前的页面，默认回首页
        const from = (location.state as any)?.from?.pathname || '/';
        navigate(from, { replace: true });
      } else {
        message.error(res.data?.errorMsg || '登录失败');
      }
    } catch (error: any) {
      message.error(error.message || '网络异常');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f0f2f5'
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={3}>后台管理系统</Title>
        </div>
        <Form
          name="admin_login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入管理员密码' }]}
          >
            <Input.Password placeholder="请输入管理员密码" />
          </Form.Item>

          <Form.Item style={{ marginTop: 32 }}>
            <Button type="primary" htmlType="submit" block loading={loading}>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;